import * as React from "react";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import { IEditorGlyph } from "./editor-glyph";

/**
 * The only way an editor's bar draws its glyph: always a mask tinted with the family colour,
 * never an `<img>`. An image keeps the asset's own strokes, and those are black or `#606F85`,
 * which vanish on the dark bar; a mask takes a token and dark mode resolves it.
 *
 * The tooltip naming the glyph (`glyph.label`) is the host's — the switcher chip and the
 * identity each wrap their own glyph (`triggerIconTooltip`, `iconTooltip`).
 */
export interface IEditorGlyphIconProps {
  glyph: IEditorGlyph;
  /** 16 on a bar. */
  size?: number;
}

export const EditorGlyphIcon = ({ glyph, size = 16 }: IEditorGlyphIconProps): React.ReactElement => (
  <KuikaSvg type={glyph.iconType} name={glyph.iconName} width={size} height={size} color={glyph.color} />
);

export default EditorGlyphIcon;
